module.exports = __webpack_public_path__ + "img/pc_logo_top.e3cb300e.png";